/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, {useEffect, useState} from 'react';
// material
import ExpandableSection from '../../../../../material/expandablesection/expandablesection';
import ConfigController from '../../../../../material/expandablesection/controllers/configcontroller/configcontroller';
import RevenueMetricsSettings from "./revenueMetrics/revenueMetrics";
// styles
import injectSheet from 'react-jss';
import styles from './advanced_styles';

// redux
import {updateAccountSettings} from "../../../../../state/thunks/account";
import {useDispatch, useSelector} from "react-redux";

import {Redirect} from "react-router";


/* ========== ~~~~~~~~~~ ADVANCED CONFIG - SENTIMENT ~~~~~~~~~~ ========== */
const AdvancedConfig = injectSheet(styles)((props) => {
    const dispatch = useDispatch();
    const accountUUID = useSelector((state) => state.session.accountUUID);
    const accountSettings = useSelector((state) => state.account.accountSettings);
    const accountSettingsRequestStatus = useSelector((state) => state.account.accountSettingsRequestStatus);

    const [isOpened, setIsOpened] = useState(false);
    const [isChanged, setIsChanged] = useState(false);

    // form
    const [settings, setSettings] = useState(accountSettings);

    useEffect(() => {
        if (JSON.stringify(settings) === JSON.stringify(accountSettings)) setIsChanged(false);
        else setIsChanged(true);
    }, [settings]);

    const handleToggle = () => {
        setIsOpened(!isOpened);
    };

    const handleCancel = () => {
        setIsOpened(false);
        setIsChanged(false);
        setSettings(accountSettings);
    };

    const handleSave = () => {
        dispatch(updateAccountSettings({settings, accountUUID}));
        setIsOpened(false);
        setIsChanged(false);
    };
    
    if (accountSettingsRequestStatus === 'error') return <Redirect to={'/error/500'} />;
    
    const controller = (
        <ConfigController
            handleToggle={handleToggle}
            handleCancel={handleCancel}
            handleSave={handleSave}
            isOpened={isOpened}
            isChanged={isChanged}
            title='Advanced Settings'
            description={''}
            cancelTitle={'Cancel'}
        />
    );
    return (
        <ExpandableSection
            className={`advancedconfig ${props.classes.advancedconfig}`}
            controller={controller}
            isOpened={isOpened}
            isChanged={isChanged}
            handleCancel={handleCancel}
            cancelTitle={'Cancel'}
            handleSave={handleSave}
            saveTitle={'Save & Close'}
        >
            <RevenueMetricsSettings setSettings={setSettings} settings={settings}/>
        </ExpandableSection>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AdvancedConfig;
